import { ChangeEvent } from "react";

export default function TextAreaInput({
    label,
    id,
    value,
    handleChange,
    required,
    showInvalid
}: {
    label: string,
    id: string,
    value?: string,
    handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    required: boolean,
    showInvalid: boolean,
}) {
    return (
        <div className="flex flex-col justify-start items-start gap-1">
            <label className={`text-[12px] text-secondary ${required ? "required" : ""}`}>{label}</label>
            <textarea
                onChange={handleChange}
                id={id}
                name={id}
                value={value}
                required={required}
                className={`${showInvalid ? "invalid:border-pink-500 invalid:text-pink-600" : ""} w-full border border-outline bg-dark text-white rounded-lg px-4 py-3 text-[14px]`}
                rows={5}
            />
        </div>
    )
}